(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  //customElements.define('localization-form', LocalizationForm);
  if (!customElements.get('localization-form')) {
    customElements.define('localization-form', LocalizationForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  // Sticky Header Functionality
  document.addEventListener('DOMContentLoaded', function() {
    const header = document.querySelector('.sticky_header');
    const headerPromo = document.querySelector('.header-promo');
    
    // Only run if sticky header is actually enabled (header has sticky_header class)
    if (header && header.classList.contains('sticky_header')) {
      let lastScrollTop = 0;
      let promoHeight = 0;
      
      // Calculate header-promo height and set header height CSS variable
      function calculatePromoHeight() {
        if (headerPromo) {
          promoHeight = headerPromo.offsetHeight;
        }
        
        // Temporarily remove scrolled class to get natural header height
        const hadScrolledClass = header.classList.contains('scrolled');
        if (hadScrolledClass) {
          header.classList.remove('scrolled');
        }
        
        // Use a timeout to ensure DOM is fully rendered
        setTimeout(() => {
          // Try to get more accurate header height
          let headerHeight = 80; // fallback value
          
          if (header) {
            const headerRect = header.getBoundingClientRect();
            headerHeight = Math.round(headerRect.height);
            
            // Additional validation - header should be reasonable height
            if (headerHeight < 40 || headerHeight > 200) {
              headerHeight = 80; // use fallback if unreasonable
            }
          }
          
          // Set header height CSS variable for margin-bottom calculation
          document.documentElement.style.setProperty('--calculated-header-height', headerHeight + 'px');
          
          console.log('Header height calculated:', headerHeight + 'px');
        }, 100);
        
        // Restore scrolled class if it was there
        if (hadScrolledClass) {
          header.classList.add('scrolled');
        }
      }
      
      // Initial calculation
      calculatePromoHeight();
      
      // Recalculate on window load for better accuracy
      window.addEventListener('load', () => {
        setTimeout(calculatePromoHeight, 200);
      });
      
      // Check initial scroll position on page load
      const initialScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (initialScrollTop > promoHeight) {
        header.classList.add('scrolled');
        if (headerPromo) {
          headerPromo.classList.add('sticky-header-enabled');
        }
      }
      
      // Recalculate on resize
      window.addEventListener('resize', calculatePromoHeight);
      
      function handleScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        
        // Add scrolled class when scrolling past header-promo
        if (scrollTop > promoHeight) {
          header.classList.add('scrolled');
          // Add margin-bottom to header-promo when header becomes sticky
          if (headerPromo) {
            headerPromo.classList.add('sticky-header-enabled');
          }
        } else {
          header.classList.remove('scrolled');
          // Remove margin-bottom when header is not sticky
          if (headerPromo) {
            headerPromo.classList.remove('sticky-header-enabled');
          }
        }
        
        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
      }
      
      // Add scroll event listener with throttling
      let ticking = false;
      function requestTick() {
        if (!ticking) {
          requestAnimationFrame(handleScroll);
          ticking = true;
          setTimeout(() => { ticking = false; }, 10);
        }
      }
      
      window.addEventListener('scroll', requestTick, { passive: true });
    } else {
      // If sticky header is not enabled, ensure header-promo doesn't have the class
      const headerPromo = document.querySelector('.header-promo');
      if (headerPromo) {
        headerPromo.classList.remove('sticky-header-enabled');
        console.log('Sticky header is disabled, removed class from header-promo');
      }
    }
  });

  // customElements.define('sticky-header', StickyHeader);
  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredient-text-image"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Find all sections with ingredient-text-image in their ID
    const ingredientSections = document.querySelectorAll('[id*="ingredient-text-image"]');
    
    if (ingredientSections.length > 0) {
      // Get the last ingredient-text-image section
      const lastSection = ingredientSections[ingredientSections.length - 1];
      
      // Remove margin-bottom from the last section
      lastSection.style.setProperty('margin-bottom', '0', 'important');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
